import { checkHealthSlice } from './connection.slice';

export const { setHealth, setIsInitApiLoading, setWSConnection } = checkHealthSlice.actions;
